import 'twin.macro';
import InputGroup from '@teetsh/app/src/components/Form/InputGroup';
import { Option } from './types';
import DeleteButton from '@teetsh/app/src/components/Buttons/DeleteButton';
import { TrashIcon as Trash } from '@heroicons/react/20/solid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ColorsListDualPalette } from 'components/Form/Colorpicker/ColorsListDualPalette';
import { ColorPaletteConfig } from 'containers/App/context/useColorPalette';

interface Props {
  onRemove: (v: string) => void;
  onChange: (v: Option) => void;
  value: Option;
  colorPalette: ColorPaletteConfig;
}

export function OptionConfiguration(props: Props) {
  const { value, onChange, onRemove, colorPalette } = props;
  const [name, setName] = useState(props.value.value);
  const { t } = useTranslation(['common']);
  return (
    <div>
      <InputGroup
        label={t('common:components.customFields.label')}
        value={name}
        autoFocus
        onBlur={() => {
          if (name !== value.value) {
            onChange({ ...value, value: name });
          }
        }}
        onChange={v => setName(v)}
      />
      <div tw="text-right">
        <DeleteButton
          portal
          onClick={() => onRemove(value.id)}
          small
          icon={Trash}
          intent="none"
          withConfirmation
          minimal
        >
          {t('common:buttons.delete')}
        </DeleteButton>
      </div>
      <ColorsListDualPalette
        onChange={c =>
          onChange({
            ...value,
            color: c,
          })
        }
        value={value.color || 'white'}
        colorPalette={colorPalette}
      />
    </div>
  );
}
